import { useSelector } from "react-redux";

import i18n from "i18next";

export const useContentSelectors = () => {
  const lang = i18n.language;

  const countries = useSelector(state => state.content.allCountries.data);
  const menuProxies = useSelector(state => state.content.menuProxy.data);
  const html = useSelector(state => state.content.html.data);
  const { store } = useSelector(store => store.content.content);

  return {
    country: countries,
    allCountry: countries[lang] || [],
    menuProxies: menuProxies[lang] || [],
    html,
    content: store,
  };
};
